import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import CategoryGrid from './components/CategoryGrid';
import TrendingVideos from './components/TrendingVideos';
import Features from './components/Features';
import FAQ from './components/FAQ';
import Newsletter from './components/Newsletter';

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '茄子视频',
  url: 'https://www.qiezitv.com',
  description: '茄子视频是一款深受用户喜爱的短视频娱乐平台，海量搞笑、生活、才艺视频等你来看。',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '400-888-8888',
    contactType: 'customer service',
    email: 'contact@qiezitv.com',
  },
  address: {
    '@type': 'PostalAddress',
    streetAddress: '茄子大厦',
    addressLocality: '北京',
    addressRegion: '北京',
    addressCountry: 'CN',
  },
};

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '茄子视频',
  url: 'https://www.qiezitv.com',
  description: '茄子视频官方入口·短视频娱乐平台',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.qiezitv.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const webpageJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '茄子视频官方入口·短视频娱乐平台',
  description: '茄子视频是一款深受用户喜爱的短视频娱乐平台，海量搞笑、生活、才艺视频等你来看。立即下载茄子视频，发现精彩内容，轻松记录生活每一刻。',
  url: 'https://www.qiezitv.com/',
  isPartOf: {
    '@type': 'WebSite',
    name: '茄子视频',
    url: 'https://www.qiezitv.com',
  },
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        item: { '@id': 'https://www.qiezitv.com/', name: '首页' },
      },
    ],
  },
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(webpageJsonLd)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar transparent />

        <main>
          {/* Hero Section */}
          <header className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20warm%20orange%20and%20teal%20gradient%20background%20with%20soft%20flowing%20waves%2C%20modern%20digital%20entertainment%20theme%2C%20playful%20abstract%20shapes%20floating%2C%20warm%20atmosphere%2C%20creative%20and%20artistic%20design%2C%20no%20text%2C%20smooth%20textures%2C%20cinematic%20lighting&width=1600&height=800&seq=qiezi-hero-bg&orientation=landscape"
              alt="茄子视频 - 短视频娱乐平台"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

            <div className="relative z-10 w-full px-4 md:px-6 text-center">
              <div className="max-w-3xl mx-auto">
                <p className="text-white/80 text-sm md:text-base mb-3 animate-fade-in">
                  发现精彩，记录生活
                </p>
                <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
                  茄子视频 — 你的短视频
                  <span className="text-primary-400">娱乐天地</span>
                </h1>
                <p className="text-white/70 text-sm md:text-base max-w-xl mx-auto mb-8 leading-relaxed">
                  海量搞笑、生活、才艺视频等你来看。与千万用户共享视频乐趣，轻松记录生活每一刻。
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                  <a
                    href="#download"
                    className="bg-primary-500 hover:bg-primary-600 text-white px-8 py-3 rounded-full text-sm md:text-base font-medium whitespace-nowrap cursor-pointer transition-all duration-200"
                  >
                    <i className="ri-download-line mr-2 w-4 h-4 inline-flex items-center justify-center"></i>
                    立即下载茄子视频
                  </a>
                  <Link
                    to="/category"
                    className="bg-white/20 hover:bg-white/30 text-white px-8 py-3 rounded-full text-sm md:text-base font-medium whitespace-nowrap cursor-pointer backdrop-blur-sm transition-all duration-200"
                  >
                    浏览视频
                    <i className="ri-arrow-right-line ml-2 w-4 h-4 inline-flex items-center justify-center"></i>
                  </Link>
                </div>
              </div>
            </div>
          </header>

          {/* Stats Bar */}
          <section className="bg-background-50 border-b border-background-200/70">
            <div className="max-w-7xl mx-auto px-4 md:px-6 py-6">
              <div className="grid grid-cols-3 gap-4 text-center">
                <div>
                  <p className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">5000万+</p>
                  <p className="text-xs md:text-sm text-foreground-500 mt-1">注册用户</p>
                </div>
                <div>
                  <p className="text-2xl md:text-3xl font-bold text-accent-500 font-heading">100万+</p>
                  <p className="text-xs md:text-sm text-foreground-500 mt-1">日活跃创作者</p>
                </div>
                <div>
                  <p className="text-2xl md:text-3xl font-bold text-secondary-500 font-heading">10亿+</p>
                  <p className="text-xs md:text-sm text-foreground-500 mt-1">日均播放量</p>
                </div>
              </div>
            </div>
          </section>

          <CategoryGrid />
          <TrendingVideos />

          {/* Download CTA Banner */}
          <section id="download" className="relative py-16 md:py-24 overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20orange%20teal%20abstract%20gradient%20with%20soft%20geometric%20patterns%2C%20modern%20digital%20vibe%2C%20playful%20yet%20professional%2C%20smooth%20flowing%20shapes%2C%20inviting%20atmosphere%2C%20clean%20design%20background&width=1600&height=600&seq=qiezi-cta-bg&orientation=landscape"
              alt=""
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-primary-500/90 to-accent-500/90"></div>

            <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
                随时随地，发现精彩内容
              </h2>
              <p className="text-white/80 text-sm md:text-base mb-8 max-w-lg mx-auto">
                下载茄子视频APP，海量搞笑、生活、才艺视频随时随地观看。iOS和Android均可下载，完全免费！
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <a
                  href="#"
                  className="bg-white text-primary-500 px-8 py-3 rounded-full text-sm md:text-base font-medium whitespace-nowrap cursor-pointer hover:bg-white/90 transition-all flex items-center gap-2"
                >
                  <i className="ri-apple-fill text-lg w-5 h-5 flex items-center justify-center"></i>
                  App Store 下载
                </a>
                <a
                  href="#"
                  className="bg-white/20 text-white border border-white/30 px-8 py-3 rounded-full text-sm md:text-base font-medium whitespace-nowrap cursor-pointer hover:bg-white/30 transition-all flex items-center gap-2 backdrop-blur-sm"
                >
                  <i className="ri-android-fill text-lg w-5 h-5 flex items-center justify-center"></i>
                  Android 下载
                </a>
              </div>
              <p className="mt-6 text-white/60 text-xs">
                支持 iOS 15+ / Android 8+  |  完全免费，无强制付费
              </p>
            </div>
          </section>

          <Features />
          <FAQ />
          <Newsletter />
        </main>

        <Footer />
      </div>
    </>
  );
}